import type { BrandProduct } from '../types';

export const forreston = {
  identity: {
    SHORT_NAME: 'Forreston',
    FULL_NAME: 'Forreston Mutual Insurance',
    LEGAL_NAME: 'Forreston Mutual Insurance Company',
    EMAIL_SENDER: 'Forreston Mutual',
    EMAIL_BCC: 'embercomms@forrestonmutual.com',
    SUPPORT_NAME: 'Forreston Mutual',
    DOMAIN: 'forrestonmutual.com',
    SUPPORT_EMAIL: 'info@forrestonmutual.com',
    DISPLAY_NAME: 'Forreston',
    MARKETING_NAME: 'Forreston Mutual Insurance',
    POLICY_ISSUER: 'Forreston Mutual Insurance Company',
    CLAIMS_HANDLER: 'Forreston',
    REFERRAL_NAME: 'Forreston Mutual',
    SOCIAL_HANDLE: 'Forreston',
    AGENCY_SUPPORT_EMAIL: 'info@forrestonmutual.com',
    // brand-config-be keeps these two split into lines (PAYMENT_ADDRESS_LINES /
    // EXPEDITED_PAYMENT_ADDRESS_LINES); its payment-address.test.ts checks the two agree.
    PAYMENT_ADDRESS: 'Forreston Mutual Insurance Company PO Box 15674 Worcester, MA 01615',
    EXPEDITED_PAYMENT_ADDRESS: 'Forreston Mutual Insurance Company 370 Main Street, Ste 880 Worcester, MA 01608',
    CUSTOMER_SERVICE_PHONE: '800-938-2270',
    CUSTOMER_SERVICE_PHONE_LETTERS: '800-938-2270',
    PRIVACY_POLICY_URL: 'https://www.forrestonmutual.com/privacy-policy/'
  },
  supportedStates: ['IL'],
  // Underwriter-selectable supplemental documents for the Policy Settings page (#34376). Appended
  // to the farm policy packet when selected; the Branch (Subscriber) Agreement is only offered on
  // migrated-renewal policies. PDFs live in the carrier policy_docs bucket under these keys.
  supplementalDocuments: [
    {
      id: 'wood-heat-questionnaire',
      label: 'Wood Heat Questionnaire',
      s3Key: 'supplemental-documents/wood-heat-questionnaire.pdf'
    },
    {
      id: 'blanket-inventory-list',
      label: 'Blanket Inventory List',
      s3Key: 'supplemental-documents/farm-blanket-inventory.pdf'
    },
    {
      id: 'branch-agreement',
      label: 'Branch Agreement',
      s3Key: 'supplemental-documents/subscriber-agreement.pdf',
      migratedRenewalsOnly: true
    },
    // #35891: Forreston's own Recurring Payment Authorization form (farm-based policies only —
    // Forreston writes no auto). s3Key must stay in lockstep with recurringPaymentAuthorizationS3Key
    // in brand-config-be's forreston.ts.
    {
      id: 'recurring-payment-authorization',
      label: 'Recurring Payment Authorization Form',
      s3Key: 'supplemental-documents/recurring-payment-authorization.pdf'
    }
  ],
  // Hold rateControlDate up to 5 days by default, 60 for underwriters (issue #32130).
  rateControlDate: { maxStaleDaysToBind: 5, underwriterMaxHoldDays: 60 },
  // Mutual: 15-day billing-hold cap, reason required, "hold cancellations as well" option available (#33568).
  billingHold: { maxDays: 15, requireReason: true, holdCancellationsEnabled: true },
  // Agents send the insured's signed cancellation request to underwriting instead of cancelling (#37502).
  agentCancellationRequestEmail: 'underwriting@forrestonmutual.com',
  // Rental needs Collision and Comprehensive, Roadside needs Collision, Lease/Loan Gap needs both (#37618).
  autoCoverageDependencies: {
    rentalRequiresCollision: true,
    roadsideRequiresCollision: true,
    loanRequiresPhysicalDamage: true,
    leaseLoanOffered: true
  }
} satisfies BrandProduct;
